import { AxiosResponse } from 'axios';
import { apiforFlow } from './api';
import getCookie from '../utils/getCookies';

const tokenSSO = getCookie('gov_access_token_sso');

export const getSolicitacoesDocumentoPendentes = (): Promise<AxiosResponse> =>
  apiforFlow.get('/flow/solicitacao-documento/pendentes/', {
    headers: {
      Authorization: `Bearer ${tokenSSO}`,
    },
  });

export const contarSolicitacoesDocumentoPendentes = (): Promise<AxiosResponse> =>
  apiforFlow.get('/flow/solicitacao-documento/contar-pendentes/', {
    headers: {
      Authorization: `Bearer ${tokenSSO}`,
    },
  });

export const anexarDocumentoSolicitado = (
  id: string,
  arquivo: File
): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append('documento_anexado', arquivo);

  return apiforFlow.patch(
    `/flow/solicitacao-documento/${id}/anexar-documento/`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${tokenSSO}`,
      },
    }
  );
};
